import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";
import { usePage } from "@inertiajs/vue3";
import { computed, ref } from "vue";

export default () => {
    const inertiaProps = usePage<IRhizomPageProps>();

    const hasDateRangeAccess = computed(() => {
        // Admin users and God mode users have access to all features regardless of subscription
        if (inertiaProps.props.isAdmin || inertiaProps.props.hasGodMode) {
            return true;
        }
        // Only Scale plan users can access date range picker
        // Block trial users
        return (
            inertiaProps.props.hasScalePlan ||
            inertiaProps.props.isTrialing ||
            inertiaProps.props.hasFreePlan
        );
    });

    const showUpgradeModal = ref(false);

    const checkAccessOrShowModal = () => {
        if (!hasDateRangeAccess.value) {
            showUpgradeModal.value = true;
            return false;
        }
        return true;
    };

    const closeUpgradeModal = () => {
        showUpgradeModal.value = false;
    };

    return {
        hasDateRangeAccess,
        showUpgradeModal,
        checkAccessOrShowModal,
        closeUpgradeModal,
    };
};
